import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
export const SeatingSelectionStep = ({
  event,
  inquiryForm,
  inquiryError,
  isCustomInquiry,
  handleSeatingPreferenceChange,
  setInquiryForm,
  openModal,
}) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const previewLength = 150;
  const description = event.venue.seatingPlanDescription || "";
  const isLong = description.length > previewLength;
  const previewText = isLong
    ? description.slice(0, previewLength) + "..."
    : description;
  const { t } = useTranslation();

  return (
    <div className="space-y-4 border-x border-b border-gray-300 p-4 rounded-b-md pt-10 pb-10">
      {inquiryError && (
        <p className="text-red-500 text-center">{inquiryError}</p>
      )}
      <div className="flex flex-col md:flex-row gap-4">
        <div className="md:w-1/2">
          <label className="text-black block mb-4 text-lg font-semibold">
            {t("EventPage.seatingPlanFor")} {event.venue.name}
          </label>

          {event.venue.seatingPlanImage ? (
            <div className="flex flex-col justify-center items-center md:justify-start md:items-start">
              <img
                src={event.venue.seatingPlanImage}
                alt={`Seating plan for ${event.venue.name}`}
                className="w-full max-w-[280px] max-h-[280px]  md:max-h-[300px] md:max-w-[300px] rounded-md cursor-pointer"
                onClick={() => openModal(event.venue.seatingPlanImage)}
              />
            </div>
          ) : (
            <div className="w-full max-w-[300px] h-[200px] bg-gray-200 rounded-md flex items-center justify-center">
              <p className="text-gray-500">{t("EventPage.NoSeatingPlanAvailable")}</p>
            </div>
          )}
        </div>
        {event.venue.seatingPlanDescription && (
          <div className="mt-4 w-full md:hidden">
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {showFullDescription ? description : previewText}
            </p>
            {isLong && (
              <button
                className="text-opera-red text-sm mt-2"
                type="button"
                onClick={() => setShowFullDescription((prev) => !prev)}
              >
                {showFullDescription ? "See less" : "See more"}
              </button>
            )}
          </div>
        )}
        <div className="lg:w-1/2">
          <label className="text-black block text-lg font-semibold mb-2">
            {t("EventPage.chooseSeatingCategory")}
          </label>

          {!event.venue.seatingPlan || event.venue.seatingPlan.length === 0 ? (
            <div className="p-4 bg-gray-100 rounded-md">
              <p className="text-gray-700">
                {t("EventPage.noSeatingPlan")}
              </p>
            </div>
          ) : (
            <div className="border border-gray-800 rounded-lg p-2">
              <div className="flex gap-4 font-semibold text-black">
                <div className="flex-1">{t("EventPage.category")}</div>
                <div className="flex-1">{t("EventPage.additionalCost")}</div>
              </div>
              <div className="space-y-0">
                {event.venue.seatingPlan.map((category, index) => (
                  <div
                    key={index}
                    onClick={() =>
                      handleSeatingPreferenceChange(category.category)
                    }
                    className={`p-2 flex gap-4 cursor-pointer transition-colors ${inquiryForm.seatingPreference === category.category
                      ? "bg-[#f5e5e4] text-black"
                      : "bg-white text-black hover:bg-gray-100"
                      }`}
                  >
                    <div className="flex-1">{category.category}</div>
                    <div className="flex-1">{category.markup >= 0 ? `+€${category.markup}` : `-€${-category.markup}`}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="border border-gray-800 rounded-lg p-2 mt-2 flex">
            <div className="pl-1 flex items-center gap-2 font-semibold text-black flex-1">
              <FontAwesomeIcon icon={faUser} />
              <div className="">{t("EventPage.Guests")}</div>
            </div>
            <div className="ml-2 flex items-center gap-4 flex-1">
              <button
                type="button"
                className="border border-gray-900 rounded-full w-8 h-8 text-black font-semibold"
                onClick={() =>
                  setInquiryForm((prev) => ({
                    ...prev,
                    numberOfGuests:
                      prev.numberOfGuests > 1 ? prev.numberOfGuests - 1 : 1,
                    hotelPreference: [],
                    seatingPreference: ""
                  }))
                }
              >
                -
              </button>
              <p className="text-black font-bold">
                {inquiryForm.numberOfGuests}
              </p>
              <button
                type="button"
                className="border border-gray-900 rounded-full w-8 h-8 text-black font-semibold"
                onClick={() =>
                  setInquiryForm((prev) => ({
                    ...prev,
                    numberOfGuests: prev.numberOfGuests + 1,
                    hotelPreference: [],
                    seatingPreference: ""
                  }))
                }
              >
                +
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Seating Plan Description - Full width below everything */}
      {event.venue.seatingPlanDescription && (
        <div className="mt-4 w-full hidden md:block text-gray-700 leading-relaxed whitespace-pre-line" dangerouslySetInnerHTML={{ __html: event.venue.seatingPlanDescription }} />
      )}
    </div>
  );
};